module.exports = __webpack_public_path__ + "static/media/5045_1100316060649_3343577_n.07dda5bc.jpg";